import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Equipment Categories"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "List of Equipment Categories and their Sub Categories")
], -1)
const _hoisted_4 = {
  class: "card-toolbar",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  "data-bs-trigger": "hover",
  title: "Click to add an equipment category"
}
const _hoisted_5 = { class: "svg-icon svg-icon-3" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Add new Equipment Category ")
const _hoisted_7 = { class: "card-body py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EquipmentCategoryModal = _resolveComponent("EquipmentCategoryModal")!
  const _component_ChildrenEquipmentCategoriesModal = _resolveComponent("ChildrenEquipmentCategoriesModal")!
  const _component_DeleteModal = _resolveComponent("DeleteModal")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_EquipmentCategoriesDataTable = _resolveComponent("EquipmentCategoriesDataTable")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _withDirectives(_createVNode(_component_EquipmentCategoryModal, {
      currentlySelectedEquipmentCategory: _ctx.currentlySelectedParentEquipmentCategory,
      title: _ctx.modalSetup.title,
      action: _ctx.modalSetup.action,
      parentEquipmentCategory: _ctx.modalSetup.parentEquipmentCategory,
      equipmentCategories: _ctx.equipmentCategoriesList,
      onSaveChanges: _ctx.saveDataFromModal
    }, null, 8, ["currentlySelectedEquipmentCategory", "title", "action", "parentEquipmentCategory", "equipmentCategories", "onSaveChanges"]), [
      [_vShow, _ctx.isThereAModalActive]
    ]),
    _createVNode(_component_ChildrenEquipmentCategoriesModal, {
      parentEquipmentCategory: _ctx.currentlySelectedParentEquipmentCategory,
      onAddNewSubCategory: _ctx.openAddNewModal,
      onEditModalOpened: _ctx.openEditModal,
      onDeleteModalOpened: _ctx.openDeleteModal
    }, null, 8, ["parentEquipmentCategory", "onAddNewSubCategory", "onEditModalOpened", "onDeleteModalOpened"]),
    _withDirectives(_createVNode(_component_DeleteModal, {
      currentlySelectedEntry: _ctx.currentlySelectedParentEquipmentCategory.name,
      onDelete: _ctx.deleteSelectedEquipmentCategory
    }, null, 8, ["currentlySelectedEntry", "onDelete"]), [
      [_vShow, _ctx.isThereAModalActive]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            href: "#",
            class: "btn btn-sm btn-success",
            "data-bs-toggle": "modal",
            "data-bs-target": "#EquipmentCategoryModal",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openAddNewModal('')), ["prevent"]))
          }, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Plus.svg" })
            ]),
            _hoisted_6
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
          : (_ctx.equipmentCategoriesList.length == 0)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                description: 
            'OOPS... Unfortunately no equipment categories were found.'
          
              }, null, 8, ["description"]))
            : (_openBlock(), _createBlock(_component_EquipmentCategoriesDataTable, {
                key: 2,
                onChildrenEquipmentCategories: _ctx.openChildrenEquipmentCategories,
                onEditModalOpened: _ctx.openEditModal,
                onDeleteModalOpened: _ctx.openDeleteModal,
                tableData: _ctx.equipmentCategoriesList
              }, null, 8, ["onChildrenEquipmentCategories", "onEditModalOpened", "onDeleteModalOpened", "tableData"]))
      ]),
      _createVNode(_component_Pagination, {
        currentPage: _ctx.pagination.current_page,
        totalPages: _ctx.pagination.last_page,
        onChangeCurrentPage: _ctx.changeSearchByPage
      }, null, 8, ["currentPage", "totalPages", "onChangeCurrentPage"])
    ])
  ], 2))
}